<template>
    <div>
        <div class="list-group mb-2 ">
            <div class="list-group-item list-group-item-action flex-column align-items-start" v-bind:class="{ 'active' : !novo }">
                <small style="font-style:italic"><i :class="icone"></i> {{tipo}}</small>
                <div class="d-flex w-100 justify-content-between" style="margin-bottom:0;">
                    <h4 class="mb-0 text-white">&nbsp;{{titulo}}</h4>
                </div>
            </div>
        </div>      
    </div>
</template>

<script>
    export default {
        props:['tipo','titulo','novo','icone'],
        name: 'HeaderTabelas'
    }
</script>

<style lang="scss">
    #page-menu-wrap{
        position:relative !important
    }
    #page-menu{
        min-height: 50px;
        margin-bottom:45px;
    }
</style>